///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { eulaFeatureKey } from './eula.state';
import { reducer } from './eula.reducers';
import { EulaEffects } from './effects/eula.effects';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(eulaFeatureKey, reducer), EffectsModule.forFeature([EulaEffects])],
    providers: []
})
export class SharedEulaStoreModule {}
